import {z} from 'zod'

import {BeforeAfterEnum, CountryCodeEnum} from '@sdox/api'

import {i18nValidation} from '../../../../i18n'

import type {BlockMetaInputWithoutDocumentId} from '@sdox/api'
import type {FieldValues} from 'react-hook-form'

export type CreateMetaSchema = z.infer<typeof createMetaSchema>

export const createMetaSchema = z.object({
  id: z.undefined(),
  panelId: z.string(),
  position: z.nativeEnum(BeforeAfterEnum),
  pullout: z.boolean(),
  needleBlockId: z.string().optional(),
  countryCodes: z.array(z.nativeEnum(CountryCodeEnum)),
})

export const getCreateMetaFromFieldValues = (fieldValues: FieldValues): BlockMetaInputWithoutDocumentId => {
  const meta: BlockMetaInputWithoutDocumentId = {
    id: undefined,
    position: fieldValues.meta.position,
    panelId: fieldValues.meta.panelId,
    pullout: fieldValues.meta.pullout,
    needleBlockId: fieldValues.meta.needleBlockId || undefined,
    countryCodes: fieldValues.meta.countryCodes,
  }

  return createMetaSchema.parse(meta)
}

export const videoProviderSchema = z.string().regex(
  /^https:\/\/(www\.)?(youtube|vimeo|youtu.be)/,
  {message: i18nValidation.invalidVideoProvider},
)
